import { render, staticRenderFns } from "./BtnMasInfo.vue?vue&type=template&id=3f0a7e58&"
import script from "./BtnMasInfo.vue?vue&type=script&lang=js&"
export * from "./BtnMasInfo.vue?vue&type=script&lang=js&"
import style0 from "./BtnMasInfo.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports